define(function (require) {
	"use strict";

	var LE = require("app");

	var template = require("user-management-templates/lobs/lobListLayout.tmpl");
	var Paging = require("ui/paging/Paging");
	var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");

	var ACTION_MENU_ITEMS = {
		ADD: "add",
		EDIT: "edit",
		DELETE: "delete"
	};

	var LobListLayout = {};

	function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

		LobListLayout = Marionette.Layout.extend({
			className: "lob-list",
			template: template,
			isPermanent: true,
			ui: {
				actionMenuContainer: ".action-menu",
				pagingContainer: ".lob-list-paging-container"
			},
			regions: {
				gridRegion: ".lobs-grid-container"
			},
			uiComponents: {
				paging: {
					type: Paging,
					options: {
						el: "view.ui.pagingContainer",
						collection: "view.collection",
						blockWrongPageNumber: true
					},
					events: {
						"change:page": "_onPagingChange"
					}
				},
				actionMenu: {
					type: DropdownMenu,
					options: {
						el: "view.ui.actionMenuContainer",
						name: LE.translator.translate("LEFramework.global.captions.action"),
						collection: "view._getActionMenuCollection"
					},
					events: {
						"change": "_onActionMenuSelected"
					}
				}
			},
			initialize: function(options) {
				this._initialize(options);
			},
			onClose: function () {
				LEUserManagement.logger.debug("closing lobs layout view", "LobListLayout::onClose");
			},
			_initialize: function(options){
				LEUserManagement.logger.debug("_initialize", "LobListLayout::_initialize");
				this.channel = LEUserManagement.media.channel(LEUserManagement.channels.LOB_LIST);
				this.collection = options.collection;
				this._bindEvents();
			},

			_bindEvents: function() {
				LEUserManagement.logger.debug("_bindEvents", "LobListLayout::_bindEvents");
				this.listenTo(this.collection ,"reset", this._onCollectionReset);
				this.listenTo(this.channel, "actionMenu:set", this._onActionMenuSet);
			},
			_onCollectionReset: function() {
				LEUserManagement.logger.debug("_onCollectionReset", "LobListLayout::_onCollectionReset");
				// set correct paging
				var currentPagingInfo = this.collection.getPagerInfo();
				this.uiComponents.paging.setInfo(currentPagingInfo.currentPageNumber, currentPagingInfo.totalPages);
			},


			_getActionMenuCollection: function() {
				LEUserManagement.logger.debug("_getActionMenuCollection", "LobListLayout::_getActionMenuCollection");
				var itemsArr = _.map(ACTION_MENU_ITEMS, function(itemId) {
					return {
						id: itemId,
						actionName : LE.translator.translate("LEFramework.global.captions." + itemId),
						align: "right",
						title: LE.translator.translate("LEFramework.global.captions." + itemId + ".tooltip")
					};
				});
				this.actionsCollection = new DropdownMenu.Collection(itemsArr);
				return this.actionsCollection;
			},

			_onActionMenuSet: function(options) {
				LEUserManagement.logger.debug("_onActionMenuSet " + options.id + " " + options.enabled, "LobListLayout::_onActionMenuSet");
				var actionItemModel = this.actionsCollection.get(options.id);
				if (!_.isEmpty(actionItemModel)) {
					actionItemModel.set("enabled", options.enabled);
				}
			},

			_onActionMenuSelected: function(componentId, eventName, selectedItemId) {
				LEUserManagement.logger.debug("_onActionMenuSelected " + selectedItemId, "LobListLayout::_onActionMenuSelected");
				this.channel.trigger("actionMenu:select", selectedItemId);
			},

			_onPagingChange: function(componentId, eventName, currentPageNumber) {
				LEUserManagement.logger.debug("_onPagingChange " + currentPageNumber, "LobListLayout::_onPagingChange");
				this.channel.trigger("paging:change", currentPageNumber);
			}
		});

	}

	LE.module("LEUserManagement", moduleDefinition);

	LobListLayout.ACTION_MENU_ITEMS = ACTION_MENU_ITEMS;

	return LobListLayout;
});
